import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AdminDashboard from "./backend/AdminDashboard";
import DashboardHome from "./backend/dashboard/DashboardHome";
import UsersPage from "./backend/users/UsersPage";
import CompaniesPage from "./backend/companies/CompaniesPage";
import CompaniesMapPage from "./frontend/pages/CompaniesMapPage";
import ImpressumPage from "./frontend/pages/ImpressumPage";
import ContactPage from "./frontend/pages/ContactPage";
import RestaurantsPage from "./frontend/pages/RestaurantsPage";
import HotelsPage from "./frontend/pages/HotelsPage";
import LatestMembersPage from "./frontend/pages/LatestMembersPage";
import PartnersPage from "./frontend/pages/PartnersPage";
import AllTopicsPage from "./frontend/pages/AllTopicsPage";
import MainLayout from "./frontend/layout/MainLayout";
import DomainsPage from "./backend/domains/DomainsPage";
import CategoriesPage from "./backend/companies/CategoriesPage";
import ClassificationsPage from "./backend/companies/ClassificationsPage";
import HotelGroupsPage from "./backend/companies/HotelGroupsPage";
import AwardsPage from "./backend/companies/AwardsPage";
import LogosPage from "./backend/companies/LogosPage";
import PartnersAdminPage from "./backend/partners/PartnersPage";
import PopularTopicsPage from "./backend/popularTopics/PopularTopicsPage";
import HriBenefitsPage from "./backend/hriBenefits/HriBenefitsPage";
import NewsletterSubscriptionsPage from "./backend/newsletter/NewsletterSubscriptionsPage";
import CuisinesPage from "./backend/companies/CuisinesPage";
import RestaurantPricesPage from "./backend/companies/RestaurantPricesPage";
import DeliveryServicesPage from "./backend/companies/DeliveryServicesPage";
import LocationsPage from "./backend/companies/LocationsPage";
import LeisureActivitiesPage from "./backend/companies/LeisureActivitiesPage";
import RegionsPage from "./backend/companies/RegionsPage";
import HotelDetailPage from "./frontend/pages/HotelDetailPage";
import AmenitiesPage from "./backend/companies/AmenitiesPage";

function ScrollToTop() {
    const { pathname, search, hash } = useLocation();

    React.useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, search, hash]);

    return null;
}

export default function MainApp() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                {/* AdminDashboard ist NUR Layout + <Outlet /> */}
                <Route path="/admin" element={<AdminDashboard />}>
                    <Route index element={<DashboardHome />} />
                    <Route path="users" element={<UsersPage />} />
                    <Route path="companies" element={<CompaniesPage />} />
                    <Route path="categories" element={<CategoriesPage />} />
                    <Route path="hotel-groups" element={<HotelGroupsPage />} />
                    <Route path="awards" element={<AwardsPage />} />
                    <Route path="logos" element={<LogosPage />} />
                    <Route path="partners" element={<PartnersAdminPage />} />
                    <Route path="popular-topics" element={<PopularTopicsPage />} />
                    <Route path="hri-benefits" element={<HriBenefitsPage />} />
                    <Route path="newsletter" element={<NewsletterSubscriptionsPage />} />
                    <Route path="cuisines" element={<CuisinesPage />} />
                    <Route path="restaurant-prices" element={<RestaurantPricesPage />} />
                    <Route path="delivery-services" element={<DeliveryServicesPage />} />
                    <Route path="locations" element={<LocationsPage />} />
                    <Route path="leisure-activities" element={<LeisureActivitiesPage />} />
                    <Route path="regions" element={<RegionsPage />} />
                    <Route path="classifications" element={<ClassificationsPage />} />
                    <Route path="domains" element={<DomainsPage />} />
                    <Route path="amenities" element={<AmenitiesPage />} />
                </Route>

                {/* --------------------- FRONTEND LAYOUT --------------------- */}
                <Route element={<MainLayout />}>
                    <Route path="/" element={<CompaniesMapPage />} />
                    <Route path="/impressum" element={<ImpressumPage />} />
                    <Route path="/hotels" element={<HotelsPage />} />
                    <Route path="/restaurants" element={<RestaurantsPage />} />
                    <Route path="/neueste-mitglieder" element={<LatestMembersPage />} />
                    <Route path="/partner" element={<PartnersPage />} />
                    <Route path="/themen" element={<AllTopicsPage />} />
                    <Route path="/kontakt" element={<ContactPage />} />
                    <Route path="/companies/:id" element={<HotelDetailPage />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
}
